/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExchangeableAppointmentResponse } from './ExchangeableAppointmentResponse';
import {
    ExchangeableAppointmentResponseFromJSON,
    ExchangeableAppointmentResponseFromJSONTyped,
    ExchangeableAppointmentResponseToJSON,
    ExchangeableAppointmentResponseToJSONTyped,
} from './ExchangeableAppointmentResponse';
import type { AppointmentExchangeOfferStatus } from './AppointmentExchangeOfferStatus';
import {
    AppointmentExchangeOfferStatusFromJSON,
    AppointmentExchangeOfferStatusFromJSONTyped,
    AppointmentExchangeOfferStatusToJSON,
    AppointmentExchangeOfferStatusToJSONTyped,
} from './AppointmentExchangeOfferStatus';

/**
 * 
 * @export
 * @interface AppointmentExchangeOfferResponse
 */
export interface AppointmentExchangeOfferResponse {
    /**
     * 
     * @type {string}
     * @memberof AppointmentExchangeOfferResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AppointmentExchangeOfferResponse
     */
    offeredByCounselorId: string;
    /**
     * 
     * @type {string}
     * @memberof AppointmentExchangeOfferResponse
     */
    offeredByCounselorUserCode: string;
    /**
     * 
     * @type {string}
     * @memberof AppointmentExchangeOfferResponse
     */
    offeredByCounselorFirstName: string;
    /**
     * 
     * @type {string}
     * @memberof AppointmentExchangeOfferResponse
     */
    offeredByCounselorLastName: string;
    /**
     * 
     * @type {string}
     * @memberof AppointmentExchangeOfferResponse
     */
    offeredAppointmentId: string;
    /**
     * 
     * @type {ExchangeableAppointmentResponse}
     * @memberof AppointmentExchangeOfferResponse
     */
    offeredAppointment: ExchangeableAppointmentResponse | null;
    /**
     * 
     * @type {string}
     * @memberof AppointmentExchangeOfferResponse
     */
    note: string | null;
    /**
     * 
     * @type {AppointmentExchangeOfferStatus}
     * @memberof AppointmentExchangeOfferResponse
     */
    status: AppointmentExchangeOfferStatus;
    /**
     * 
     * @type {Date}
     * @memberof AppointmentExchangeOfferResponse
     */
    createdAtUtc: Date;
}



/**
 * Check if a given object implements the AppointmentExchangeOfferResponse interface.
 */
export function instanceOfAppointmentExchangeOfferResponse(value: object): value is AppointmentExchangeOfferResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('offeredByCounselorId' in value) || value['offeredByCounselorId'] === undefined) return false;
    if (!('offeredByCounselorUserCode' in value) || value['offeredByCounselorUserCode'] === undefined) return false;
    if (!('offeredByCounselorFirstName' in value) || value['offeredByCounselorFirstName'] === undefined) return false;
    if (!('offeredByCounselorLastName' in value) || value['offeredByCounselorLastName'] === undefined) return false;
    if (!('offeredAppointmentId' in value) || value['offeredAppointmentId'] === undefined) return false;
    if (!('offeredAppointment' in value) || value['offeredAppointment'] === undefined) return false;
    if (!('note' in value) || value['note'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('createdAtUtc' in value) || value['createdAtUtc'] === undefined) return false;
    return true;
}

export function AppointmentExchangeOfferResponseFromJSON(json: any): AppointmentExchangeOfferResponse {
    return AppointmentExchangeOfferResponseFromJSONTyped(json, false);
}

export function AppointmentExchangeOfferResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentExchangeOfferResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'offeredByCounselorId': json['offeredByCounselorId'],
        'offeredByCounselorUserCode': json['offeredByCounselorUserCode'],
        'offeredByCounselorFirstName': json['offeredByCounselorFirstName'],
        'offeredByCounselorLastName': json['offeredByCounselorLastName'],
        'offeredAppointmentId': json['offeredAppointmentId'],
        'offeredAppointment': ExchangeableAppointmentResponseFromJSON(json['offeredAppointment']),
        'note': json['note'],
        'status': AppointmentExchangeOfferStatusFromJSON(json['status']),
        'createdAtUtc': (new Date(json['createdAtUtc'])),
    };
}

export function AppointmentExchangeOfferResponseToJSON(json: any): AppointmentExchangeOfferResponse {
    return AppointmentExchangeOfferResponseToJSONTyped(json, false);
}

export function AppointmentExchangeOfferResponseToJSONTyped(value?: AppointmentExchangeOfferResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'offeredByCounselorId': value['offeredByCounselorId'],
        'offeredByCounselorUserCode': value['offeredByCounselorUserCode'],
        'offeredByCounselorFirstName': value['offeredByCounselorFirstName'],
        'offeredByCounselorLastName': value['offeredByCounselorLastName'],
        'offeredAppointmentId': value['offeredAppointmentId'],
        'offeredAppointment': ExchangeableAppointmentResponseToJSON(value['offeredAppointment']),
        'note': value['note'],
        'status': AppointmentExchangeOfferStatusToJSON(value['status']),
        'createdAtUtc': value['createdAtUtc'].toISOString(),
    };
}

